export default function AffAmazon() {
  return (
    <a
      href="https://amzn.to/4vvrSOD"
      className="amazon-main-btn"
      target="_blank"
      rel="noopener noreferrer nofollow"
    >
      Amazon Store
    </a>
  );
}
